// extracted by mini-css-extract-plugin
export var fadeIn = "_n1-1";
export var modalContent = "_n1-3";
export var overlay = "_n1-0";
export var popoverContent = "_n1-2";
export var results = "_n1-5";
export var searchInputWrapper = "_n1-4";